import styled from "styled-components"
import media from "styled-media-query"

export const PracticeAreasWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 1024px;
  margin: 4rem auto;
  padding: 1rem;
`

export const Title = styled.h2`
  margin-bottom: 2rem;
  font-size: 2rem;
  font-weight: 800;
  color: var(--blue);
  text-transform: uppercase;
  text-align: center;
`

export const PracticeAreasContainer = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: 2rem;
`

// export const Button = styled(OutboundLink)`
//   display: block;
//   margin-top: 2rem;
//   padding: 1.25rem 4rem;
//   border: 2px solid var(--lightBlue);
//   background: var(--lightBlue);
//   font-size: 1rem;
//   color: var(--white);
//   font-weight: 700;
//   text-align: center;
//   text-decoration: none;
//   cursor: pointer;
//   transition: all .5s;

//   &:hover{
//     transform: scale(1.1)
//   }
// `

export const Button = styled.a`
  display: flex;
  align-items: center;  
  margin-top: 2rem;
  padding: 1.25rem 4rem;
  border: none;
  box-shadow: 0.25rem 0.25rem 1rem rgba(0, 0, 0,0.8);
  background: #34af23;
  font-size: 1rem;
  color: var(--white);
  font-weight: 700;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  transition: all .5s;

  &:hover{
    transform: scale(1.1)
  }

  ${media.lessThan("large")`
    margin-top: 1.5rem;
    padding: 0.75rem 3rem;
    font-size: 0.85rem;
  `}

  ${media.lessThan("medium")`
    margin-top: 1.25rem;
  `}

  ${media.lessThan("small")`
    margin-top: 1rem;
    padding: 0.5rem 2rem;
    font-size: 0.7rem;
  `}
`

export const IconWrapper = styled.div`
  width: 1rem;
  height: 1.1rem;
  margin-right: .25rem;
`